var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3"},[_c('R-Toaster'),(!_vm.loadingCustomer)?_c('router-view'):_vm._e(),_c('ModalCustomerLock',{attrs:{"require-customer-token":_vm.$route.meta.requiresCustomerToken,"require-pbx":_vm.$route.meta.requiresPbx}}),_c('ModalFeedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }